import { render } from "./FilterUsagesLink.vue?vue&type=template&id=8b65f152&scoped=true"
import script from "./FilterUsagesLink.vue?vue&type=script&lang=js"
export * from "./FilterUsagesLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b65f152"]])

export default __exports__